import { render, staticRenderFns } from "./MailEdit.vue?vue&type=template&id=679f0d6e"
import script from "./MailEdit.vue?vue&type=script&lang=js"
export * from "./MailEdit.vue?vue&type=script&lang=js"
import style0 from "./MailEdit.vue?vue&type=style&index=0&id=679f0d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports